/* =====================================================================
   pegconf-plan.js — clé de plan, géométrie de la grille et export DXF
   =====================================================================
   Module partagé, sans dépendance :
     - le configurateur (pegconf.js) l'utilise pour dessiner la grille et le
       logo de l'aperçu, et pour écrire la clé « Plan » dans la commande ;
     - la page atelier (snippets/pegconf-atelier.liquid) l'utilise pour
       décoder la clé, afficher l'aperçu et générer le DXF.
   Une seule implémentation de la géométrie => l'aperçu client, la clé et le
   plan de découpe coïncident toujours.

   Clé « A1-960-480-15S2B-7Q » :
     A1        version du format (entraxe 30 mm, trous Ø 6,1, marge 30 mm)
     960-480   largeur × hauteur en millimètres entiers
     15S2B     épaisseur (mm) · forme S (coins droits) / R (arrondis R30) /
               C (Curves, bords ondulés) · lignes de marge sans trous (0-9) ·
               matière (lettre)
     2X1J15    (optionnel) panneau en plusieurs morceaux : nx × ny, marge de jointure
     K100050000025 (optionnel, forme R) arrondi de chaque coin en % de l'arrondi maximal,
               3 chiffres par coin dans l'ordre haut-gauche, haut-droit, bas-droit, bas-gauche ;
               100 % = la moitié du plus petit côté ; absent = R30 aux 4 coins (arrondi standard)
     M2001     (optionnel) marges par côté, en lignes : haut, droite, bas, gauche
     Z80X80R100L450B300 (optionnel, répétable) réservation : largeur × hauteur (mm), arrondi des
               angles (%), centre à L mm du bord gauche et B mm du bas
     7Q       somme de contrôle (CRC-16 sur le reste, 2 caractères)
   Constantes lues dans window.PEGCONF_CFG (snippets/pegair-config.liquid).
   ===================================================================== */
(function () {
  'use strict';

  const VERSION = 'A1';
  const LOGO_W_MM = 40, LOGO_H_MM = 10.28;
  /* logo Aire « aıre• » (sans point sur le i), tracé en mm, origine en haut à gauche, fill-rule evenodd */
  const LOGO_PATH = 'M 9.23 10.03 C 8.95 10.2 8.56 10.28 8.07 10.28 C 7.65 10.28 7.32 10.16 7.07 9.93 C 6.83 9.69 6.7 9.31 6.7 8.78 C 6.26 9.31 5.74 9.69 5.16 9.93 C 4.57 10.16 3.93 10.28 3.25 10.28 C 2.8 10.28 2.38 10.23 1.98 10.13 C 1.59 10.03 1.24 9.87 0.95 9.65 C 0.66 9.44 0.43 9.16 0.26 8.81 C 0.09 8.46 0 8.04 0 7.55 C 0 6.99 0.09 6.53 0.28 6.18 C 0.47 5.82 0.72 5.54 1.03 5.31 C 1.34 5.09 1.7 4.92 2.1 4.81 C 2.5 4.7 2.91 4.6 3.32 4.53 C 3.77 4.44 4.19 4.37 4.59 4.33 C 4.99 4.28 5.34 4.22 5.64 4.14 C 5.94 4.05 6.18 3.93 6.36 3.78 C 6.54 3.62 6.63 3.39 6.63 3.08 C 6.63 2.73 6.56 2.44 6.43 2.23 C 6.3 2.01 6.12 1.85 5.92 1.73 C 5.71 1.62 5.47 1.54 5.21 1.51 C 4.95 1.47 4.7 1.45 4.44 1.45 C 3.76 1.45 3.19 1.58 2.73 1.84 C 2.28 2.1 2.03 2.59 1.99 3.31 L 0.38 3.31 C 0.4 2.7 0.53 2.19 0.76 1.77 C 0.99 1.35 1.29 1.02 1.67 0.76 C 2.05 0.5 2.48 0.31 2.97 0.2 C 3.46 0.08 3.98 0.03 4.54 0.03 C 4.98 0.03 5.42 0.06 5.86 0.12 C 6.3 0.18 6.69 0.31 7.05 0.51 C 7.4 0.71 7.68 0.98 7.9 1.34 C 8.12 1.69 8.22 2.15 8.22 2.72 L 8.22 7.77 C 8.22 8.15 8.25 8.43 8.29 8.61 C 8.33 8.79 8.48 8.87 8.74 8.87 C 8.87 8.87 9.04 8.84 9.23 8.78 Z M 6.61 5 C 6.41 5.15 6.14 5.26 5.81 5.33 C 5.48 5.4 5.14 5.46 4.78 5.5 C 4.42 5.55 4.05 5.6 3.68 5.66 C 3.32 5.71 2.99 5.8 2.7 5.93 C 2.41 6.06 2.17 6.24 1.98 6.47 C 1.8 6.71 1.71 7.03 1.71 7.43 C 1.71 7.7 1.76 7.92 1.87 8.11 C 1.98 8.29 2.12 8.44 2.29 8.55 C 2.46 8.67 2.66 8.75 2.89 8.8 C 3.11 8.85 3.35 8.87 3.61 8.87 C 4.14 8.87 4.6 8.8 4.98 8.66 C 5.36 8.51 5.67 8.33 5.91 8.11 C 6.15 7.88 6.32 7.64 6.44 7.38 C 6.55 7.12 6.61 6.88 6.61 6.65 Z M 11.77 0.25 L 11.77 10.07 L 13.39 10.07 L 13.39 0.25 Z M 16.79 0.25 L 16.79 10.07 L 18.4 10.07 L 18.4 5.7 C 18.4 5.07 18.46 4.51 18.59 4.02 C 18.72 3.54 18.92 3.12 19.2 2.78 C 19.48 2.44 19.84 2.18 20.3 2 C 20.76 1.82 21.31 1.73 21.95 1.73 L 21.95 0.03 C 21.08 0 20.36 0.18 19.79 0.56 C 19.22 0.94 18.74 1.53 18.34 2.32 L 18.31 2.32 L 18.31 0.25 Z M 30.59 4.22 L 24.95 4.22 C 24.98 3.84 25.06 3.48 25.2 3.15 C 25.34 2.81 25.53 2.52 25.77 2.27 C 26.01 2.01 26.3 1.81 26.63 1.67 C 26.97 1.52 27.35 1.45 27.76 1.45 C 28.17 1.45 28.54 1.52 28.87 1.67 C 29.21 1.81 29.5 2.01 29.75 2.26 C 30 2.5 30.19 2.8 30.34 3.14 C 30.48 3.48 30.57 3.84 30.59 4.22 Z M 32.15 6.96 L 30.56 6.96 C 30.42 7.6 30.13 8.08 29.69 8.4 C 29.25 8.72 28.69 8.87 28.01 8.87 C 27.48 8.87 27.02 8.79 26.62 8.61 C 26.23 8.43 25.91 8.19 25.66 7.9 C 25.4 7.6 25.22 7.26 25.11 6.87 C 24.99 6.49 24.94 6.08 24.95 5.65 L 32.3 5.65 C 32.33 5.05 32.27 4.42 32.14 3.77 C 32.01 3.11 31.77 2.5 31.42 1.94 C 31.07 1.39 30.61 0.93 30.03 0.57 C 29.46 0.21 28.73 0.03 27.86 0.03 C 27.19 0.03 26.57 0.15 26.01 0.41 C 25.44 0.66 24.96 1.01 24.55 1.47 C 24.13 1.92 23.81 2.46 23.59 3.08 C 23.36 3.7 23.24 4.39 23.24 5.13 C 23.27 5.88 23.38 6.57 23.58 7.2 C 23.77 7.84 24.07 8.38 24.46 8.84 C 24.85 9.29 25.34 9.65 25.91 9.9 C 26.49 10.15 27.17 10.28 27.95 10.28 C 29.07 10.28 29.99 10 30.73 9.44 C 31.46 8.89 31.94 8.06 32.15 6.96 Z M 38.36 3.51 C 39.27 3.51 40 4.25 40 5.15 C 40 6.06 39.27 6.79 38.36 6.79 C 37.46 6.79 36.73 6.06 36.73 5.15 C 36.73 4.25 37.46 3.51 38.36 3.51 Z';
  /* pastels (2026-09) : P = bleu Pastel, Y = rouge rubY, E = vert d'Eau, G = oranGe pastel */
  const MATERIALS = { bouleau: 'B', blanc: 'W', osb: 'K', noir: 'N', bleu: 'U', vert: 'V', jaune: 'J', ral: 'R', bleu_pastel: 'P', rouge_rubis: 'Y', vert_eau: 'E', orange_pastel: 'G' };
  const MATERIAL_BY_CODE = {};
  Object.keys(MATERIALS).forEach((k) => { MATERIAL_BY_CODE[MATERIALS[k]] = k; });
  const MATERIAL_LABELS = { bouleau: 'Bouleau nature', blanc: 'Blanc', osb: 'OSB', noir: 'Noir', bleu: 'Bleu', vert: 'Vert', jaune: 'Jaune', ral: 'RAL personnalisé', bleu_pastel: 'Bleu pastel', rouge_rubis: 'Rouge rubis', vert_eau: 'Vert d\'eau', orange_pastel: 'Orange pastel' };
  /* alphabet de la somme de contrôle : ni 0/O ni 1/I */
  const ALPHABET = '23456789ABCDEFGHJKLMNPQRSTUVWXYZ';

  const num = (v, d) => { const n = Number(v); return isFinite(n) ? n : d; };
  function cfg() {
    const C = window.PEGCONF_CFG || {};
    return {
      spacing: Math.max(1, num(C.hole_spacing_mm, 30)),
      marginCenter: Math.max(0, num(C.margin_center_mm, 30)),
      holeD: 6.1,
      cornerR: 30,
      minMm: Math.round(num(C.min_cm, 9) * 10),
      maxWMm: Math.round(num(C.max_width_cm, 450) * 10),
      maxHMm: Math.round(num(C.max_cm, 300) * 10),
      maxMarginLines: Math.max(0, Math.min(9, Math.round(num(C.max_margin_lines, 5)))),
      /* plateau machine : au-delà, le panneau est fabriqué en plusieurs morceaux égaux */
      bedW: Math.round(num(C.bed_w_cm, 248) * 10),
      bedH: Math.round(num(C.bed_h_cm, 147) * 10),
      /* marge au bord de jointure entre deux morceaux : 30 mm (défaut) ou 15 mm (grille continue) */
      jointDefault: 30,
      jointOptions: [15, 30],
      /* forme Curves : période visée des ondulations, profondeur des creux, côté minimal */
      curvesPeriod: Math.max(60, num(C.curves_period_mm, 160)),
      curvesDepth: Math.max(0, num(C.curves_depth_mm, 25)),
      /* part du bombé dans l'ondulation (0,5 = sinusoïde ; 0,62 = bombés longs, creux courts, comme le Curves 48 × 48) */
      curvesBump: Math.min(0.8, Math.max(0.5, num(C.curves_bump_ratio, 0.62))),
      curvesMinMm: Math.round(num(C.curves_min_cm, 24) * 10),
      /* niveaux d'ondulation (curseur) : 0 = période/creux de base ; chaque niveau ajoute curves_step_mm
         à la période visée, et le creux grandit dans la même proportion (lobes moins nombreux, plus grands) */
      curvesStep: Math.max(10, num(C.curves_step_mm, 40)),
      curvesMaxLevel: Math.max(0, Math.min(9, Math.round(num(C.curves_max_level, 5)))),
      /* réservations (découpes) : nombre max., côté min., matière min. jusqu'au bord du panneau,
         écart min. entre deux réservations / avec une jointure, distance min. centre de trou -> découpe */
      cutoutMax: Math.max(0, Math.min(9, Math.round(num(C.cutout_max, 6)))),
      cutoutMin: Math.max(5, num(C.cutout_min_mm, 20)),
      cutoutEdge: Math.max(0, num(C.cutout_edge_mm, 10)),
      cutoutGap: Math.max(0, num(C.cutout_gap_mm, 20)),
      cutoutClear: Math.max(0, num(C.cutout_clear_mm, 10)),
      /* trous de fixation (vis au mur, dans les trous de la trame) : grands côtés 2 vis jusqu'à fix_long_first_mm,
         puis 1 de plus par fix_step_mm ; petits côtés : 1 vis au milieu à partir de fix_short_first_mm, puis 1 de plus par fix_step_mm */
      fixLongFirst: Math.max(100, num(C.fix_long_first_mm, 960)),
      fixShortFirst: Math.max(100, num(C.fix_short_first_mm, 1440)),
      fixStep: Math.max(100, num(C.fix_step_mm, 960))
    };
  }

  /* ---------- découpe en morceaux ----------
     Un panneau qui ne tient pas sur le plateau (dans un sens ou dans l'autre)
     est découpé en nx × ny morceaux égaux, le moins possible, dans l'orientation
     de plateau la plus favorable. Les tailles sont entières (mm) et égales à
     1 mm près (le reste de la division est réparti sur les premiers morceaux). */
  function pieceCount(W, H, c) {
    const fits = (w, h) => (w <= c.bedW && h <= c.bedH) || (w <= c.bedH && h <= c.bedW);
    if (fits(W, H)) return { nx: 1, ny: 1 };
    const a = { nx: Math.ceil(W / c.bedW), ny: Math.ceil(H / c.bedH) };
    const b = { nx: Math.ceil(W / c.bedH), ny: Math.ceil(H / c.bedW) };
    return (b.nx * b.ny < a.nx * a.ny) ? b : a;
  }
  function splitEqual(total, n) {
    const base = Math.floor(total / n), rem = total - base * n, out = [];
    for (let i = 0; i < n; i++) out.push(base + (i < rem ? 1 : 0));
    return out;
  }
  const clampJoint = (j, c) => (c.jointOptions.indexOf(Math.round(num(j, c.jointDefault))) >= 0) ? Math.round(num(j, c.jointDefault)) : c.jointDefault;

  /* ---------- coins arrondis réglables (2026-09-29) ----------
     Chaque coin a son arrondi en % (0 = angle droit, 100 = arrondi maximal). L'arrondi maximal
     est la moitié du plus petit côté : deux coins voisins à 100 % se rejoignent (bout en
     demi-cercle), les quatre à 100 % donnent un disque (carré) ou une forme « stade ».
     Sans réglage (corners absent) : R30 aux 4 coins, comme avant (clé, aperçu, DXF inchangés). */
  const CORNER_KEYS = ['tl', 'tr', 'br', 'bl'];
  /* [tl, tr, br, bl] en % entiers 0-100, ou null (arrondi standard R30) */
  function clampCorners(a) {
    if (!a || typeof a !== 'object') return null;
    const arr = Array.isArray(a) ? a : CORNER_KEYS.map((k) => a[k]);
    if (arr.length !== 4) return null;
    const out = arr.map((v) => Math.max(0, Math.min(100, Math.round(num(v, NaN)))));
    return out.every((v) => isFinite(v)) ? out : null;
  }
  const cornerMaxR = (W, H) => Math.min(W, H) / 2;
  /* rayons (mm) de chaque coin pour des % donnés */
  function cornerRadii(W, H, pcts) {
    const m = cornerMaxR(W, H), r = {};
    CORNER_KEYS.forEach((k, i) => { r[k] = m * pcts[i] / 100; });
    return r;
  }
  /* contour fermé d'un rectangle à coins arrondis (mm, y vers le bas), sens horaire à l'écran,
     départ en haut à gauche ; arcs de cercle échantillonnés tous les `step` mm environ */
  function roundedOutline(W, H, r, step) {
    step = step || 2;
    const pts = [];
    const arc = (cx, cy, R, t0) => {
      if (!(R > 0)) { pts.push([cx + R * Math.cos(t0), cy + R * Math.sin(t0)]); return; }
      const k = Math.max(4, Math.ceil(Math.PI / 2 * R / step));
      for (let i = 0; i <= k; i++) { const t = t0 + Math.PI / 2 * i / k; pts.push([cx + R * Math.cos(t), cy + R * Math.sin(t)]); }
    };
    arc(r.tl, r.tl, r.tl, Math.PI);
    arc(W - r.tr, r.tr, r.tr, 3 * Math.PI / 2);
    arc(W - r.br, H - r.br, r.br, 0);
    arc(r.bl, H - r.bl, r.bl, Math.PI / 2);
    /* points confondus (deux arcs qui se rejoignent) */
    return pts.filter((pt, i) => { const q = pts[(i + pts.length - 1) % pts.length]; return Math.abs(pt[0] - q[0]) > 1e-6 || Math.abs(pt[1] - q[1]) > 1e-6; });
  }
  /* même contour en chemin SVG exact (arcs), pour l'aperçu */
  function roundedPathD(W, H, r) {
    const n = (v) => (Math.round(v * 100) / 100).toString();
    const A = (R, x, y) => (R > 0) ? 'A' + n(R) + ' ' + n(R) + ' 0 0 1 ' + n(x) + ' ' + n(y) : 'L' + n(x) + ' ' + n(y);
    return 'M0 ' + n(r.tl) + A(r.tl, r.tl, 0) + 'L' + n(W - r.tr) + ' 0' + A(r.tr, W, r.tr) + 'L' + n(W) + ' ' + n(H - r.br) + A(r.br, W - r.br, H) +
      'L' + n(r.bl) + ' ' + n(H) + A(r.bl, 0, H - r.bl) + 'Z';
  }
  /* profondeur du bord bas à l'abscisse x (0 hors des coins) */
  function roundedBottomDepth(x, W, r) {
    if (r.bl > 0 && x < r.bl) { const u = r.bl - x; return r.bl - Math.sqrt(Math.max(0, r.bl * r.bl - u * u)); }
    if (r.br > 0 && x > W - r.br) { const u = x - (W - r.br); return r.br - Math.sqrt(Math.max(0, r.br * r.br - u * u)); }
    return 0;
  }
  /* distance (signée, > 0 à l'intérieur) d'un point au contour arrondi, dans la zone d'un coin ; Infinity ailleurs */
  function cornerClearance(x, y, W, H, r) {
    let d = Infinity;
    const test = (R, cx, cy, inX, inY) => { if (R > 0 && inX && inY) d = Math.min(d, R - Math.hypot(x - cx, y - cy)); };
    test(r.tl, r.tl, r.tl, x < r.tl, y < r.tl);
    test(r.tr, W - r.tr, r.tr, x > W - r.tr, y < r.tr);
    test(r.br, W - r.br, H - r.br, x > W - r.br, y > H - r.br);
    test(r.bl, r.bl, H - r.bl, x < r.bl, y > H - r.bl);
    return d;
  }
  /* applique des arrondis réglables : contour, trous trop près d'un coin retirés
     (même règle que Curves : centre à moins de marge − 10 mm du contour), logo remonté si besoin */
  function applyCorners(g, pcts) {
    const r = cornerRadii(g.W, g.H, pcts);
    g.corners = pcts.slice();
    g.radii = r;
    g.cornerR = 0;
    g.outline = (st) => roundedOutline(g.W, g.H, r, st);
    g.outlineD = roundedPathD(g.W, g.H, r);
    /* DXF : arcs exacts (bulge) si chaque arc tient dans le morceau de son coin, sinon polyligne découpée */
    const cornerPiece = { tl: g.pieces[0], tr: g.pieces[g.nx - 1], bl: g.pieces[(g.ny - 1) * g.nx], br: g.pieces[g.nx * g.ny - 1] };
    g.arcsFit = CORNER_KEYS.every((k) => r[k] <= Math.min(cornerPiece[k].w, cornerPiece[k].h) + 1e-9);
    /* trous */
    const dmin = Math.max(0, g.margin - 10), SP = g.spacing, list = [];
    let removed = 0;
    g.pieces.forEach((q, pk) => {
      for (let row = 0; row < q.rows; row++) {
        for (let col = 0; col < q.cols; col++) {
          const x = q.x + q.firstCx + col * SP, y = q.y + q.firstCy + row * SP;
          if (cornerClearance(x, y, g.W, g.H, r) < dmin) { removed++; continue; }
          list.push([x, y, pk]);
        }
      }
    });
    if (removed) {
      g.holeList = list;
      g.holes = list.length;
    }
    /* logo : même position qu'avant, remonté au-dessus de l'arrondi des coins du bas s'il le faut */
    if (g.logo) {
      const q = g.pieces.find((pc) => pc.logo) || g.pieces[0];
      const bandTop = (q.rows > 0) ? q.y + q.lastCy + g.holeR : q.y;
      const depthAt = (x0) => { let d = 0; for (let x = x0; x <= x0 + LOGO_W_MM + 0.01; x += 1) d = Math.max(d, roundedBottomDepth(x, g.W, r)); return d; };
      /* position d'origine, puis glissement vers le centre du panneau (dans le morceau) si l'arrondi gêne */
      const x0 = g.logo.x, dir = (g.W / 2 >= x0 + LOGO_W_MM / 2) ? 1 : -1;
      const xMin = q.x + 2, xMax = q.x + q.w - 2 - LOGO_W_MM;
      let placed = false;
      for (let x = x0; x >= xMin - 1e-6 && x <= xMax + 1e-6; x += dir * 5) {
        const depth = depthAt(x);
        if (depth === 0 && x === x0) { placed = true; break; }
        if (g.H - depth - bandTop >= LOGO_H_MM + 2) { g.logo.x = x; g.logo.y = (bandTop + g.H - depth) / 2 - LOGO_H_MM / 2; placed = true; break; }
      }
      if (!placed) { g.logo = null; q.logo = null; }
    }
    return g;
  }

  /* ---------- forme Curves (bords ondulés) ----------
     Même dessin que les Curves standards (48 × 48 : 3 lobes par côté ; 96 × 48 : 6 × 3).
     Chaque côté porte un nombre entier de lobes (période ≈ 160 mm, 2 lobes minimum) ;
     entre deux sommets, un creux de 25 mm fait de deux arcs de cercle tangents : un grand
     arc bombé et un arc de creux plus court (le bombé occupe ~62 % de l'ondulation,
     mesuré sur le Curves 48 × 48 : effet plus doux qu'une sinusoïde) ; chaque coin est un quart
     d'ellipse de rayons (px/2, py/2), tangent aux deux côtés à leur premier sommet.
     Au-delà du plateau : découpe en morceaux comme un rectangle, contour extérieur ondulé,
     jonctions droites (chaque morceau = contour ondulé coupé par le rectangle du morceau).
     Trous : grille standard, moins ceux dont le centre est à moins de (marge − 10) mm
     du contour (20 mm en marge standard : même rangée du haut que le Curves 48 × 48,
     « ..ooo..ooo..oo. » → 2-3-2 trous entre les creux). */
  const clampWaves = (L, c) => Math.max(0, Math.min(c.curvesMaxLevel, Math.round(num(L, 0))));
  function curvesSpec(W, H, c, level) {
    c = c || cfg();
    const L = clampWaves(level, c);
    const per = c.curvesPeriod + L * c.curvesStep;               /* période visée */
    const depth = c.curvesDepth * per / c.curvesPeriod;          /* creux proportionnel */
    const nx = Math.max(2, Math.round(W / per)), ny = Math.max(2, Math.round(H / per));
    const px = W / nx, py = H / ny;
    return { level: L, period: per, nx, ny, px, py, a: px / 2, b: py / 2, A: Math.min(depth, 0.3 * Math.min(px, py)), bump: c.curvesBump };
  }
  /* profondeur de l'ondulation à la distance t d'un sommet (période per) : arc bombé de rayon Rc
     depuis le sommet, puis arc de creux de rayon Rv, tangents ; Rc + Rv = (h² + A²) / 2A, h = per / 2 */
  function curvesWave(t, per, s) {
    const A = s.A, h = per / 2;
    if (!(A > 0)) return 0;
    let u = ((t % per) + per) % per; if (u > h) u = per - u;
    const S = (h * h + A * A) / (2 * A), Rc = s.bump * S, Rv = S - Rc, xi = h * s.bump;
    if (u <= xi) return Rc - Math.sqrt(Math.max(0, Rc * Rc - u * u));
    const v = h - u;
    return A - (Rv - Math.sqrt(Math.max(0, Rv * Rv - v * v)));
  }
  /* la forme Curves est-elle possible pour ces dimensions (mm) ? (côté minimal ; au-delà du plateau : plusieurs morceaux) */
  function curvesFits(W, H, c) {
    c = c || cfg();
    return W >= c.curvesMinMm && H >= c.curvesMinMm;
  }
  /* découpe d'un contour fermé par un rectangle (Sutherland-Hodgman) : le contour ondulé ne traverse
     chaque ligne de jonction qu'une fois par bord, le résultat est donc un contour fermé propre */
  function clipRect(pts, x0, y0, x1, y1) {
    const edges = [
      [(p) => p[0] >= x0, (a, b) => { const t = (x0 - a[0]) / (b[0] - a[0]); return [x0, a[1] + t * (b[1] - a[1])]; }],
      [(p) => p[0] <= x1, (a, b) => { const t = (x1 - a[0]) / (b[0] - a[0]); return [x1, a[1] + t * (b[1] - a[1])]; }],
      [(p) => p[1] >= y0, (a, b) => { const t = (y0 - a[1]) / (b[1] - a[1]); return [a[0] + t * (b[0] - a[0]), y0]; }],
      [(p) => p[1] <= y1, (a, b) => { const t = (y1 - a[1]) / (b[1] - a[1]); return [a[0] + t * (b[0] - a[0]), y1]; }]
    ];
    let out = pts;
    edges.forEach(([inside, cross]) => {
      const src = out; out = [];
      for (let i = 0; i < src.length; i++) {
        const cur = src[i], prev = src[(i + src.length - 1) % src.length];
        const ci = inside(cur), pi = inside(prev);
        if (ci) { if (!pi) out.push(cross(prev, cur)); out.push(cur); }
        else if (pi) out.push(cross(prev, cur));
      }
    });
    return out;
  }
  /* contour fermé (coordonnées de l'aperçu : mm, y vers le bas), sens horaire à l'écran,
     un point tous les `step` mm environ ; départ au sommet du coin haut-gauche */
  function curvesOutline(W, H, s, step) {
    step = step || 2;
    const a = s.a, b = s.b, pts = [];
    const wave = (t, per) => curvesWave(t, per, s);
    const n = (len) => Math.max(1, Math.ceil(len / step));
    const arc = (cx, cy, t0, t1) => {
      const k = n(Math.PI / 2 * Math.max(a, b));
      for (let i = 1; i <= k; i++) { const t = t0 + (t1 - t0) * i / k; pts.push([cx + a * Math.cos(t), cy + b * Math.sin(t)]); }
    };
    const LW = W - 2 * a, LH = H - 2 * b;
    pts.push([a, 0]);
    let m = n(LW);
    for (let i = 1; i <= m; i++) { const x = a + LW * i / m; pts.push([x, wave(x - a, s.px)]); }
    arc(W - a, b, -Math.PI / 2, 0);
    m = n(LH);
    for (let i = 1; i <= m; i++) { const y = b + LH * i / m; pts.push([W - wave(y - b, s.py), y]); }
    arc(W - a, H - b, 0, Math.PI / 2);
    m = n(LW);
    for (let i = 1; i <= m; i++) { const x = W - a - LW * i / m; pts.push([x, H - wave(x - a, s.px)]); }
    arc(a, H - b, Math.PI / 2, Math.PI);
    m = n(LH);
    for (let i = 1; i <= m; i++) { const y = H - b - LH * i / m; pts.push([wave(y - b, s.py), y]); }
    arc(a, b, Math.PI, 3 * Math.PI / 2);
    pts.pop(); /* = premier point */
    return pts;
  }
  /* profondeur du bord haut / bas à l'abscisse x (0 sur un sommet) */
  function edgeDepth(t, L, a, b, per, s) {
    if (t <= a) { const u = (a - t) / a; return b - b * Math.sqrt(Math.max(0, 1 - u * u)); }
    if (t >= L - a) { const u = (t - (L - a)) / a; return b - b * Math.sqrt(Math.max(0, 1 - u * u)); }
    return curvesWave(t - a, per, s);
  }
  function curvesEdgeDepth(x, W, s) { return edgeDepth(x, W, s.a, s.b, s.px, s); }
  /* point (mm, y vers le bas) à l'intérieur du contour Curves ? (le contour est l'intersection des 4 bords ondulés) */
  function curvesInside(x, y, W, H, s) {
    const dT = edgeDepth(x, W, s.a, s.b, s.px, s), dL = edgeDepth(y, H, s.b, s.a, s.py, s);
    return y >= dT && y <= H - dT && x >= dL && x <= W - dL;
  }
  /* applique la forme Curves à une géométrie d'un seul morceau : liste explicite des trous, logo sur un lobe */
  function applyCurves(g, c, level) {
    const s = curvesSpec(g.W, g.H, c, level);
    const SP = g.spacing;
    const pts = curvesOutline(g.W, g.H, s, 2);
    /* index spatial du contour (cases de 20 mm) */
    const CELL = 20, cells = {};
    pts.forEach((pt) => { const k = Math.floor(pt[0] / CELL) + ',' + Math.floor(pt[1] / CELL); (cells[k] = cells[k] || []).push(pt); });
    const dmin = Math.max(0, g.margin - 10), d2 = dmin * dmin, r = Math.ceil(dmin / CELL) + 1;
    const reach = Math.max(s.a, s.b, s.A) + dmin + 1;
    const list = [];
    /* trous : grille de chaque morceau (marges de jonction inchangées), filtrée près du bord ondulé */
    g.pieces.forEach((q, pk) => {
    for (let row = 0; row < q.rows; row++) {
      for (let col = 0; col < q.cols; col++) {
        const x = q.x + q.firstCx + col * SP, y = q.y + q.firstCy + row * SP;
        let ok = true;
        /* près du bord : le trou doit être dans la forme (grands creux) et assez loin du contour */
        if (Math.min(x, g.W - x, y, g.H - y) < reach && !curvesInside(x, y, g.W, g.H, s)) ok = false;
        else if (Math.min(x, g.W - x, y, g.H - y) < reach) {
          const cx = Math.floor(x / CELL), cy = Math.floor(y / CELL);
          for (let i = -r; i <= r && ok; i++) {
            for (let j = -r; j <= r && ok; j++) {
              const cell = cells[(cx + i) + ',' + (cy + j)];
              if (!cell) continue;
              for (let k = 0; k < cell.length; k++) { const dx = cell[k][0] - x, dy = cell[k][1] - y; if (dx * dx + dy * dy < d2) { ok = false; break; } }
            }
          }
        }
        if (ok) list.push([x, y, pk]);
      }
    }
    });
    /* logo : sur le morceau du bas prévu pour le logo, sur le sommet de lobe le plus proche de son centre
       (centre exact si un lobe y est) */
    const q = g.pieces.find((pc) => pc.i === Math.floor((g.nx - 1) / 2) && pc.j === g.ny - 1) || g.pieces[0];
    const target = q.x + q.w / 2;
    let lx = target;
    for (let k = 1; k <= s.nx - 2; k++) {
      const xp = s.a + k * s.px;
      if (xp - LOGO_W_MM / 2 >= q.x + 2 && xp + LOGO_W_MM / 2 <= q.x + q.w - 2 && (lx === target || Math.abs(xp - target) < Math.abs(lx - target) - 1e-6)) lx = xp;
    }
    let depth = 0;
    for (let x = lx - LOGO_W_MM / 2; x <= lx + LOGO_W_MM / 2 + 0.01; x += 2) depth = Math.max(depth, curvesEdgeDepth(x, g.W, s));
    const bandTop = (q.rows > 0) ? q.y + q.lastCy + g.holeR : 0, bottom = g.H - depth;
    g.pieces.forEach((pc) => { pc.logo = null; });
    g.logo = (q.w >= LOGO_W_MM + 4 && bottom - bandTop >= LOGO_H_MM + 2) ? { x: lx - LOGO_W_MM / 2, y: (bandTop + bottom) / 2 - LOGO_H_MM / 2, w: LOGO_W_MM, h: LOGO_H_MM } : null;
    q.logo = g.logo;
    g.shape = 'curves';
    g.curves = s;
    g.holeList = list;
    g.holes = list.length;
    g.outline = (st) => curvesOutline(g.W, g.H, s, st);
    g.gridLabel = g.pieces.map((pc) => pc.cols + 'x' + pc.rows).join('+');
    return g;
  }
  /* contour en chemin SVG (aperçu), précision 0,1 mm */
  function outlinePath(g, step) {
    if (g.outlineD) return g.outlineD;
    const pts = g.outline ? g.outline(step || 3) : [[0, 0], [g.W, 0], [g.W, g.H], [0, g.H]];
    return 'M' + pts.map((pt) => pt[0].toFixed(1) + ' ' + pt[1].toFixed(1)).join('L') + 'Z';
  }

  /* ---------- réservations (découpes rectangulaires, 2026-10-12) ----------
     Pour laisser passer une prise, un interrupteur, un câble… Chaque réservation :
     { w, h, r, x, y } en mm entiers — largeur, hauteur, arrondi des angles en % (0 = angle droit,
     100 = moitié du plus petit côté : bouts ronds, cercle si w = h), position du CENTRE mesurée
     depuis le bord gauche (x) et depuis le bas (y) du panneau, comme le client la mesure au mur.
     Trous à moins de cutoutClear mm (centre -> bord de la découpe) retirés ; logo déplacé le long
     du bas, ou non gravé, s'il chevauche une découpe. */
  function clampCutouts(a, c) {
    c = c || cfg();
    if (!Array.isArray(a)) return [];
    const out = [];
    a.forEach((o) => {
      if (out.length >= c.cutoutMax || !o) return;
      const v = Array.isArray(o) ? { w: o[0], h: o[1], r: o[2], x: o[3], y: o[4] } : o;
      const w = Math.round(num(v.w, NaN)), h = Math.round(num(v.h, NaN)), x = Math.round(num(v.x, NaN)), y = Math.round(num(v.y, NaN));
      if (![w, h, x, y].every((n) => isFinite(n)) || w <= 0 || h <= 0) return;
      const lim = (n) => Math.max(0, Math.min(9999, n));
      out.push({ w: lim(w), h: lim(h), r: Math.max(0, Math.min(100, Math.round(num(v.r, 0)))), x: lim(x), y: lim(y) });
    });
    return out;
  }
  /* boîte de la découpe dans le repère de l'aperçu (mm, y vers le bas) ; R = rayon des angles */
  function cutoutBox(o, H) {
    const cx = o.x, cy = H - o.y;
    return { cx, cy, x0: cx - o.w / 2, x1: cx + o.w / 2, y0: cy - o.h / 2, y1: cy + o.h / 2, R: Math.min(o.w, o.h) / 2 * o.r / 100 };
  }
  /* distance signée d'un point au contour de la découpe (> 0 dehors, < 0 dedans) */
  function cutoutDist(b, x, y) {
    const hw = (b.x1 - b.x0) / 2, hh = (b.y1 - b.y0) / 2, R = b.R;
    const qx = Math.abs(x - b.cx) - (hw - R), qy = Math.abs(y - b.cy) - (hh - R);
    return Math.hypot(Math.max(qx, 0), Math.max(qy, 0)) + Math.min(Math.max(qx, qy), 0) - R;
  }
  /* chemin SVG exact de la découpe (arcs) */
  function cutoutPathD(b) {
    const n = (v) => (Math.round(v * 100) / 100).toString(), R = b.R;
    if (!(R > 0)) return 'M' + n(b.x0) + ' ' + n(b.y0) + 'H' + n(b.x1) + 'V' + n(b.y1) + 'H' + n(b.x0) + 'Z';
    const A = (x, y) => 'A' + n(R) + ' ' + n(R) + ' 0 0 1 ' + n(x) + ' ' + n(y);
    return 'M' + n(b.x0 + R) + ' ' + n(b.y0) + 'H' + n(b.x1 - R) + A(b.x1, b.y0 + R) + 'V' + n(b.y1 - R) + A(b.x1 - R, b.y1) +
      'H' + n(b.x0 + R) + A(b.x0, b.y1 - R) + 'V' + n(b.y0 + R) + A(b.x0 + R, b.y0) + 'Z';
  }
  /* contour échantillonné (contrôle de la distance au bord d'une forme arrondie / Curves) */
  function cutoutPoints(b, step) {
    const R = b.R, w = b.x1 - b.x0, h = b.y1 - b.y0;
    const pts = roundedOutline(w, h, { tl: R, tr: R, br: R, bl: R }, step || 3).map((pt) => [b.x0 + pt[0], b.y0 + pt[1]]);
    /* côtés droits : points intermédiaires */
    const out = [];
    pts.forEach((pt, i) => {
      const q = pts[(i + 1) % pts.length], L = Math.hypot(q[0] - pt[0], q[1] - pt[1]), k = Math.max(1, Math.ceil(L / (step || 3)));
      for (let j = 0; j < k; j++) out.push([pt[0] + (q[0] - pt[0]) * j / k, pt[1] + (q[1] - pt[1]) * j / k]);
    });
    return out;
  }
  function insidePoly(P, x, y) {
    let inside = false;
    for (let i = 0, j = P.length - 1; i < P.length; j = i++) {
      const a = P[i], b = P[j];
      if (((a[1] > y) !== (b[1] > y)) && (x < (b[0] - a[0]) * (y - a[1]) / (b[1] - a[1]) + a[0])) inside = !inside;
    }
    return inside;
  }
  function distPoly(P, x, y) {
    let d = Infinity;
    for (let i = 0, j = P.length - 1; i < P.length; j = i++) {
      const a = P[j], b = P[i], dx = b[0] - a[0], dy = b[1] - a[1], L2 = dx * dx + dy * dy;
      const t = L2 > 0 ? Math.max(0, Math.min(1, ((x - a[0]) * dx + (y - a[1]) * dy) / L2)) : 0;
      d = Math.min(d, Math.hypot(x - (a[0] + t * dx), y - (a[1] + t * dy)));
    }
    return d;
  }
  /* ---------- réservations qui touchent ou dépassent le bord : encoches ----------
     Le contour du panneau est alors entaillé : contour − découpe (découpe convexe). On suit le contour ;
     à chaque entrée dans la découpe, on rejoint le point de sortie par le bord de la découpe, du côté
     qui reste dans le panneau. */
  function segInter(a, b, c, d) {
    const rx = b[0] - a[0], ry = b[1] - a[1], sx = d[0] - c[0], sy = d[1] - c[1];
    const den = rx * sy - ry * sx;
    if (Math.abs(den) < 1e-12) return null;
    const qx = c[0] - a[0], qy = c[1] - a[1];
    const t = (qx * sy - qy * sx) / den, u = (qx * ry - qy * rx) / den;
    return (t >= 0 && t < 1 && u >= 0 && u < 1) ? [t, u] : null;
  }
  function polyBox(P) {
    let x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    P.forEach((p) => { x0 = Math.min(x0, p[0]); x1 = Math.max(x1, p[0]); y0 = Math.min(y0, p[1]); y1 = Math.max(y1, p[1]); });
    return { x0, y0, x1, y1 };
  }
  /* sommets du bord de Q entre les positions qa et qb (indices fractionnaires), sens dir (+1 / −1) */
  function arcPts(Q, qa, qb, dir) {
    const m = Q.length, ia = Math.floor(qa), ib = Math.floor(qb), out = [];
    let cnt;
    if (dir > 0) { cnt = (ib - ia + m) % m; if (cnt === 0 && qb < qa) cnt = m; for (let k = 1; k <= cnt; k++) out.push(Q[(ia + k) % m]); }
    else { cnt = (ia - ib + m) % m; if (cnt === 0 && qb > qa) cnt = m; for (let k = 0; k < cnt; k++) out.push(Q[(ia - k + m) % m]); }
    return out;
  }
  function subtractConvex(P, Q) {
    const n = P.length, m = Q.length, qb = polyBox(Q);
    const inQ = (p) => p[0] >= qb.x0 && p[0] <= qb.x1 && p[1] >= qb.y0 && p[1] <= qb.y1 && insidePoly(Q, p[0], p[1]);
    let s = -1;
    for (let i = 0; i < n; i++) if (!inQ(P[i])) { s = i; break; }
    if (s < 0) return null;
    const out = [];
    let entry = null;
    for (let k = 0; k < n; k++) {
      const a = P[(s + k) % n], b = P[(s + k + 1) % n];
      if (!entry) out.push(a);
      if (Math.max(a[0], b[0]) < qb.x0 || Math.min(a[0], b[0]) > qb.x1 || Math.max(a[1], b[1]) < qb.y0 || Math.min(a[1], b[1]) > qb.y1) continue;
      const ev = [];
      for (let j = 0; j < m; j++) {
        const r = segInter(a, b, Q[j], Q[(j + 1) % m]);
        if (r) ev.push({ t: r[0], q: j + r[1], p: [a[0] + r[0] * (b[0] - a[0]), a[1] + r[0] * (b[1] - a[1])] });
      }
      ev.sort((e1, e2) => e1.t - e2.t);
      ev.forEach((e) => {
        if (!entry) { out.push(e.p); entry = e; return; }
        const fw = arcPts(Q, entry.q, e.q, 1), bw = arcPts(Q, entry.q, e.q, -1);
        const mid = (L) => L.length ? L[Math.floor(L.length / 2)] : [(entry.p[0] + e.p[0]) / 2, (entry.p[1] + e.p[1]) / 2];
        const fm = mid(fw);
        (insidePoly(P, fm[0], fm[1]) ? fw : bw).forEach((pt) => out.push(pt));
        out.push(e.p);
        entry = null;
      });
    }
    return out;
  }
  /* problème de chaque réservation (null = OK) — les encoches (réservation qui touche ou dépasse le bord)
     sont permises : 'size' trop petite · 'outside' hors du panneau · 'split' coupe le panneau en deux ·
     'edge' à l'intérieur mais à moins de cutoutEdge mm du bord (sans le toucher) · 'joint' sur une
     jointure entre deux morceaux · 'overlap' trop près d'une autre réservation */
  function cutoutIssues(g, c) {
    c = c || cfg();
    const list = g.cutouts || [], G = c.cutoutGap;
    const out = list.map((o) => {
      const b = o.box0;
      if (o.w < c.cutoutMin || o.h < c.cutoutMin) return 'size';
      if (o.outside) return 'outside';
      if (o.split) return 'split';
      if (!o.notch && o.gap < c.cutoutEdge - 1e-6) return 'edge';
      if ((g.jointsX || []).some((x) => b.x0 - G < x && b.x1 + G > x) || (g.jointsY || []).some((y) => b.y0 - G < y && b.y1 + G > y)) return 'joint';
      return null;
    });
    list.forEach((o, i) => {
      if (out[i]) return;
      const a = o.box;
      const hit = list.some((p, j) => j !== i && out[j] !== 'size' && out[j] !== 'outside' && a.x0 < p.box.x1 + G && p.box.x0 < a.x1 + G && a.y0 < p.box.y1 + G && p.box.y0 < a.y1 + G);
      if (hit) out[i] = 'overlap';
    });
    return out;
  }
  function applyCutouts(g, list, c) {
    g.cutouts = list.map((o) => { const b = cutoutBox(o, g.H); return Object.assign({}, o, { box: b, box0: b }); });
    g.cutoutIssues = [];
    if (!g.cutouts.length) return g;
    const W = g.W, H = g.H, TOUCH = 0.5;
    /* contour de base (avant encoches) */
    const baseOutline = g.outline || (g.cornerR ? (st) => roundedOutline(W, H, { tl: g.cornerR, tr: g.cornerR, br: g.cornerR, bl: g.cornerR }, st) : () => [[0, 0], [W, 0], [W, H], [0, H]]);
    const dev = g.curves ? Math.max(g.curves.a, g.curves.b, g.curves.A) : (g.radii ? Math.max(g.radii.tl, g.radii.tr, g.radii.br, g.radii.bl) : (g.cornerR || 0));
    let P = null;
    const base = () => P || (P = baseOutline(2));
    g.cutouts.forEach((o) => {
      const b = o.box0;
      const gaps = [b.x0, b.y0, W - b.x1, H - b.y1];
      if (b.x1 <= 0 || b.y1 <= 0 || b.x0 >= W || b.y0 >= H) { o.outside = true; return; }
      if ((b.x0 <= TOUCH && b.x1 >= W - TOUCH) || (b.y0 <= TOUCH && b.y1 >= H - TOUCH)) { o.split = true; return; }
      /* distance au bord : rectangle englobant, puis contour réel près des coins arrondis / ondulations */
      let gap = Math.min.apply(null, gaps), touch = gap <= TOUCH;
      if (!touch && dev > 0 && gap < c.cutoutEdge + dev) {
        const pts = cutoutPoints(b, 2), Pb = base();
        let dmin = Infinity, out = false;
        pts.forEach((pt) => { if (!insidePoly(Pb, pt[0], pt[1])) out = true; dmin = Math.min(dmin, distPoly(Pb, pt[0], pt[1])); });
        touch = out || dmin <= TOUCH; gap = dmin;
      }
      o.gap = gap;
      if (!touch) return;
      o.notch = true;
      /* côté qui coïncide avec le bord (à 0,5 mm près) : prolongé au-delà, angles compris, pour une encoche nette sans languette de bois */
      const R = b.R, ext = R + 2, e = Object.assign({}, b);
      if (Math.abs(gaps[0]) <= TOUCH) e.x0 = Math.min(e.x0, -ext);
      if (Math.abs(gaps[1]) <= TOUCH) e.y0 = Math.min(e.y0, -ext);
      if (Math.abs(gaps[2]) <= TOUCH) e.x1 = Math.max(e.x1, W + ext);
      if (Math.abs(gaps[3]) <= TOUCH) e.y1 = Math.max(e.y1, H + ext);
      e.cx = (e.x0 + e.x1) / 2; e.cy = (e.y0 + e.y1) / 2;
      o.box = e;
    });
    /* contour entaillé (encoches valides seulement) ; la découpe d'une encoche couvrant tout le panneau est ignorée */
    const notches = g.cutouts.filter((o) => o.notch);
    if (notches.length) {
      const cache = {};
      g.outline = (st) => {
        const k = st || 2;
        if (cache[k]) return cache[k];
        let poly = baseOutline(k);
        notches.forEach((o) => { const r = subtractConvex(poly, cutoutPoints(o.box, Math.max(1, Math.min(3, k)))); if (r && r.length >= 3) poly = r; else o.outside = true; });
        return (cache[k] = poly);
      };
      g.outlineD = null;
      g.arcsFit = false;
      g.notched = true;
      g.outline(2);
    }
    /* grille régulière avant découpe (pour les cotes de marges de l'aperçu) */
    g.regularGrid = !g.holeList;
    let src = g.holeList;
    if (!src) {
      src = [];
      g.pieces.forEach((q, pk) => {
        for (let row = 0; row < q.rows; row++) for (let col = 0; col < q.cols; col++) src.push([q.x + q.firstCx + col * g.spacing, q.y + q.firstCy + row * g.spacing, pk]);
      });
    }
    const keep = src.filter((h) => g.cutouts.every((o) => o.outside || o.split || cutoutDist(o.box, h[0], h[1]) >= c.cutoutClear));
    g.cutoutHolesRemoved = src.length - keep.length;
    if (keep.length !== src.length || g.holeList) { g.holeList = keep; g.holes = keep.length; }
    /* logo : glissé le long du bas (dans son morceau) pour éviter les découpes, sinon non gravé */
    if (g.logo) {
      const L = g.logo, q = g.pieces.find((pc) => pc.logo) || g.pieces[0], pad = 5;
      const act = g.cutouts.filter((o) => !o.outside && !o.split);
      const clearAt = (x) => act.every((o) => o.box.x1 + pad <= x || o.box.x0 - pad >= x + L.w || o.box.y1 + pad <= L.y || o.box.y0 - pad >= L.y + L.h);
      const edgeOk = (x) => {
        let d = 0;
        for (let xx = x; xx <= x + L.w + 0.01; xx += 2) d = Math.max(d, g.curves ? curvesEdgeDepth(xx, g.W, g.curves) : (g.radii ? roundedBottomDepth(xx, g.W, g.radii) : (g.cornerR && (xx < g.cornerR || xx > g.W - g.cornerR) ? g.cornerR : 0)));
        return L.y + L.h <= g.H - d - 1;
      };
      if (!clearAt(L.x)) {
        const xMin = q.x + 2, xMax = q.x + q.w - 2 - L.w;
        let found = null;
        for (let s = 5; s <= q.w && found == null; s += 5) {
          for (const x of [L.x - s, L.x + s]) { if (x >= xMin - 1e-6 && x <= xMax + 1e-6 && clearAt(x) && edgeOk(x)) { found = x; break; } }
        }
        if (found != null) L.x = found;
        else { g.logo = null; g.pieces.forEach((pc) => { pc.logo = null; }); g.logoHiddenByCutout = true; }
      }
    }
    g.cutoutIssues = cutoutIssues(g, c);
    return g;
  }
  /* contour du panneau en chemin SVG, découpes intérieures comprises (à remplir en fill-rule evenodd) ;
     les encoches sont déjà dans le contour */
  function bodyPathD(g, rx) {
    let d = g.outline ? outlinePath(g, 2) : (rx > 0 ? roundedPathD(g.W, g.H, { tl: rx, tr: rx, br: rx, bl: rx }) : 'M0 0H' + g.W + 'V' + g.H + 'H0Z');
    (g.cutouts || []).forEach((o) => { if (!o.notch && !o.outside && !o.split) d += cutoutPathD(o.box); });
    return d;
  }

  /* ---------- trous de fixation (2026-10-12) ----------
     Les vis passent dans des trous de la trame. Règle (par morceau) :
       grand côté  : 2 vis jusqu'à 96 cm, 3 jusqu'à 192 cm, puis +1 par tranche de 96 cm ;
       petit côté  : 2 vis (les angles) sous 144 cm, 3 à partir de 144 cm, puis +1 par tranche de 96 cm ;
       carré       : les côtés horizontaux comptent comme grands côtés.
     Total = 2 × grand + 2 × petit − 4 (angles partagés). Angles = trou le plus proche de chaque coin ;
     vis intermédiaires réparties régulièrement entre les vis d'angle, sur le trou libre le plus proche. */
  function fixCounts(w, h, c) {
    c = c || cfg();
    const horiz = w >= h, L = Math.max(w, h), S = Math.min(w, h);
    const nL = (L <= c.fixLongFirst) ? 2 : Math.ceil(L / c.fixStep - 1e-9) + 1;
    const nS = (S < c.fixShortFirst) ? 2 : 3 + Math.floor((S - c.fixShortFirst) / c.fixStep + 1e-9);
    return { horiz, nL, nS, top: horiz ? nL : nS, side: horiz ? nS : nL };
  }
  function computeFixings(g, c) {
    c = c || cfg();
    const out = [];
    g.pieces.forEach((q, pk) => {
      let holes;
      if (g.holeList) holes = g.holeList.filter((hh) => hh[2] === pk);
      else { holes = []; for (let row = 0; row < q.rows; row++) for (let col = 0; col < q.cols; col++) holes.push([q.x + q.firstCx + col * g.spacing, q.y + q.firstCy + row * g.spacing, pk]); }
      if (!holes.length) return;
      const used = new Set();
      const nearest = (x, y) => {
        let best = -1, bd = Infinity;
        holes.forEach((hh, i) => { if (used.has(i)) return; const d = (hh[0] - x) * (hh[0] - x) + (hh[1] - y) * (hh[1] - y); if (d < bd) { bd = d; best = i; } });
        if (best >= 0) { used.add(best); out.push([holes[best][0], holes[best][1], pk]); return holes[best]; }
        return null;
      };
      const n = fixCounts(q.w, q.h, c);
      const TL = nearest(q.x, q.y), TR = nearest(q.x + q.w, q.y), BR = nearest(q.x + q.w, q.y + q.h), BL = nearest(q.x, q.y + q.h);
      const edge = (A, B, cnt) => { if (!A || !B) return; for (let k = 1; k < cnt - 1; k++) nearest(A[0] + (B[0] - A[0]) * k / (cnt - 1), A[1] + (B[1] - A[1]) * k / (cnt - 1)); };
      edge(TL, TR, n.top); edge(BL, BR, n.top); edge(TL, BL, n.side); edge(TR, BR, n.side);
    });
    return out;
  }
  const fixKey = (x, y) => Math.round(x * 100) + ',' + Math.round(y * 100);

  /* ---------- géométrie ----------
     p = { wMm, hMm, marginLines, marginSides, rounded, joint, nx, ny }
     marginSides (facultatif) = [haut, droite, bas, gauche] en lignes de trous : marges
     indépendantes par côté (réglage « Avancé ») ; à défaut, marginLines sur les 4 côtés.
     -> panneau entier + un objet par morceau (position, grille locale, marges),
     lignes de coupe, logo. Positions en mm depuis le coin haut-gauche du
     panneau (axe y vers le bas, comme l'aperçu SVG).
     Marges : bord extérieur = marge de centrage + lignes de marge sans trous ;
     bord de jointure = 15 ou 30 mm exactement (les lignes de marge ne
     s'appliquent qu'aux bords extérieurs). La grille de chaque morceau est
     calée sur la jointure ; le reste de division va au bord extérieur. */
  /* marges par côté [haut, droite, bas, gauche] en lignes (0-9) ; null si absent ou invalide */
  function normSides(a, lines) {
    if (Array.isArray(a) && a.length === 4 && a.every((v) => isFinite(parseInt(v, 10)))) return a.map((v) => Math.max(0, Math.min(9, Math.round(parseInt(v, 10)))));
    return [lines, lines, lines, lines];
  }
  const sidesUniform = (a) => a[0] === a[1] && a[1] === a[2] && a[2] === a[3];
  function grid(p) {
    const c = cfg();
    const W = Math.round(p.wMm), H = Math.round(p.hMm);
    const SP = c.spacing, R = c.holeD / 2;
    const lines = Math.max(0, Math.round(num(p.marginLines, 0)));
    const sides = normSides(p.marginSides, lines);
    const MoutT = c.marginCenter + sides[0] * SP, MoutR = c.marginCenter + sides[1] * SP;
    const MoutB = c.marginCenter + sides[2] * SP, MoutL = c.marginCenter + sides[3] * SP;
    const Mout = Math.min(MoutT, MoutR, MoutB, MoutL);
    const joint = clampJoint(p.joint, c);
    const curves = (p.shape === 'curves');
    let nx = Math.round(num(p.nx, 0)), ny = Math.round(num(p.ny, 0));
    if (!(nx >= 1 && ny >= 1)) { const pc = pieceCount(W, H, c); nx = pc.nx; ny = pc.ny; }
    const widths = splitEqual(W, nx), heights = splitEqual(H, ny);
    const rounded = !!p.rounded && !curves;
    const logoCol = Math.floor((nx - 1) / 2), logoRow = ny - 1;

    const pieces = [];
    let y0 = 0;
    for (let j = 0; j < ny; j++) {
      let x0 = 0;
      for (let i = 0; i < nx; i++) {
        const w = widths[i], h = heights[j];
        const mL = (i === 0) ? MoutL : joint, mR = (i === nx - 1) ? MoutR : joint;
        const mT = (j === 0) ? MoutT : joint, mB = (j === ny - 1) ? MoutB : joint;
        const spanW = w - mL - mR, spanH = h - mT - mB;
        const cols = (spanW >= 0) ? Math.floor(spanW / SP) + 1 : 0;
        const rows = (spanH >= 0) ? Math.floor(spanH / SP) + 1 : 0;
        const extraW = Math.max(0, spanW - ((cols > 0) ? (cols - 1) * SP : 0));
        const extraH = Math.max(0, spanH - ((rows > 0) ? (rows - 1) * SP : 0));
        /* reste de division : réparti des deux côtés sur un panneau simple (grille centrée) ;
           sur un morceau, il va entièrement côté extérieur pour que la marge de jointure
           soit exacte (15 ou 30 mm) — si les deux bords sont des jointures, il est centré */
        const jL = (i > 0), jR = (i < nx - 1), jT = (j > 0), jB = (j < ny - 1);
        const firstCx = mL + ((jL === jR) ? extraW / 2 : (jL ? 0 : extraW));   /* local au morceau */
        const firstCy = mT + ((jT === jB) ? extraH / 2 : (jT ? 0 : extraH));
        const lastCy = (rows > 0) ? firstCy + (rows - 1) * SP : 0;
        const bandTop = (rows > 0) ? lastCy + R : 0;
        let logo = null;
        if (i === logoCol && j === logoRow && w >= LOGO_W_MM + 4 && h - bandTop >= LOGO_H_MM + 2) {
          logo = { x: x0 + (w - LOGO_W_MM) / 2, y: y0 + (bandTop + h) / 2 - LOGO_H_MM / 2, w: LOGO_W_MM, h: LOGO_H_MM };
        }
        pieces.push({
          i, j, x: x0, y: y0, w, h,
          margins: { l: mL, r: mR, t: mT, b: mB },
          cols, rows, firstCx, firstCy, lastCy,
          gridX: x0 + firstCx - SP / 2, gridY: y0 + firstCy - SP / 2,   /* global */
          edgeL: Math.round(firstCx), edgeR: Math.round(w - (firstCx + Math.max(0, cols - 1) * SP)),
          edgeT: Math.round(firstCy), edgeB: Math.round(h - (firstCy + Math.max(0, rows - 1) * SP)),
          corners: { tl: rounded && i === 0 && j === 0, tr: rounded && i === nx - 1 && j === 0, br: rounded && i === nx - 1 && j === ny - 1, bl: rounded && i === 0 && j === ny - 1 },
          logo
        });
        x0 += w;
      }
      y0 += heights[j];
    }
    const jointsX = [], jointsY = [];
    for (let i = 1, x = 0; i < nx; i++) { x += widths[i - 1]; jointsX.push(x); }
    for (let j = 1, y = 0; j < ny; j++) { y += heights[j - 1]; jointsY.push(y); }
    const first = pieces[0];
    const logoPiece = pieces.find((q) => q.logo) || null;
    const g = {
      W, H, spacing: SP, holeR: R, holeD: c.holeD, margin: Mout, marginLines: sidesUniform(sides) ? sides[0] : lines,
      marginSides: sidesUniform(sides) ? null : sides,
      cornerR: rounded ? c.cornerR : 0, rounded, shape: rounded ? 'rounded' : 'straight', holeList: null, outline: null,
      nx, ny, multi: nx * ny > 1, joint, widths, heights, pieces, jointsX, jointsY,
      /* compatibilité : la grille du premier morceau (= la seule sur un panneau simple) */
      cols: first.cols, rows: first.rows, firstCx: first.firstCx, firstCy: first.firstCy, lastCy: first.lastCy, gridX: first.gridX, gridY: first.gridY,
      holes: pieces.reduce((s, q) => s + q.cols * q.rows, 0),
      gridLabel: (nx * ny > 1) ? pieces.map((q) => q.cols + 'x' + q.rows).join('+') : (first.cols + 'x' + first.rows),
      logo: logoPiece ? logoPiece.logo : null
    };
    const cuts = clampCutouts(p.cutouts, c);
    const pcts = (!curves && rounded) ? clampCorners(p.corners) : null;
    const out = applyCutouts(curves ? applyCurves(g, c, p.waves) : (pcts ? applyCorners(g, pcts) : g), cuts, c);
    out.fixings = computeFixings(out, c);
    return out;
  }

  /* ---------- clé ---------- */
  function crc16(str) {
    let crc = 0xFFFF;
    for (let i = 0; i < str.length; i++) {
      crc ^= str.charCodeAt(i) << 8;
      for (let b = 0; b < 8; b++) crc = (crc & 0x8000) ? ((crc << 1) ^ 0x1021) & 0xFFFF : (crc << 1) & 0xFFFF;
    }
    return crc;
  }
  const checksum = (body) => { const c = crc16(body.toUpperCase()); return ALPHABET[(c >> 5) & 31] + ALPHABET[c & 31]; };

  /* p = { wMm, hMm, thickness, rounded, shape, marginLines, marginSides, material, joint }
     Marges différentes selon les côtés : chiffre de marge à 0 et segment « M » + 4 chiffres
     (haut, droite, bas, gauche), omis si les 4 côtés sont égaux -> clés existantes inchangées.
     Panneau en plusieurs morceaux : segment supplémentaire « 2x1J15 » (nx × ny, marge de jointure),
     pour que le plan reste reproductible même si le plateau change plus tard. */
  function encodeKey(p) {
    const W = Math.round(p.wMm), H = Math.round(p.hMm), T = Math.round(p.thickness);
    if (!(W > 0 && H > 0 && T > 0)) return '';
    const mat = MATERIALS[String(p.material || '').toLowerCase()] || 'B';
    const form = (p.shape === 'curves') ? 'C' : (p.rounded ? 'R' : 'S');
    const g = grid(p);
    let body = VERSION + '-' + W + '-' + H + '-' + T + form + (g.marginSides ? 0 : Math.max(0, Math.min(9, g.marginLines))) + mat;
    if (g.multi) body += '-' + g.nx + 'X' + g.ny + 'J' + g.joint;
    /* Curves : niveau d'ondulation (segment « W2 »), omis au niveau 0 -> clés Curves existantes inchangées */
    if (g.curves && g.curves.level > 0) body += '-W' + g.curves.level;
    /* coins réglables : segment « K » + 3 chiffres par coin (tl tr br bl), omis pour l'arrondi standard R30 */
    if (g.corners) body += '-K' + g.corners.map((v) => ('00' + v).slice(-3)).join('');
    if (g.marginSides) body += '-M' + g.marginSides.join('');
    /* réservations : un segment « Z » par découpe — largeur X hauteur R arrondi (%) L centre depuis la gauche
       B centre depuis le bas (mm) ; absent sans réservation -> clés existantes inchangées */
    (g.cutouts || []).forEach((o) => { body += '-Z' + o.w + 'X' + o.h + 'R' + o.r + 'L' + o.x + 'B' + o.y; });
    return body + '-' + checksum(body);
  }

  /* tolérant : espaces, minuscules, séparateurs variés, O/I tapés à la place de 0/1 dans les nombres */
  function normalizeKey(str) {
    let s = String(str || '').toUpperCase().trim().replace(/[\s_.\/\\]+/g, '-').replace(/[–—]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
    const seg = s.split('-');
    if (seg.length === 5 || seg.length === 6) {
      const fixDigits = (x) => x.replace(/O/g, '0').replace(/[IL]/g, '1');
      seg[1] = fixDigits(seg[1]); seg[2] = fixDigits(seg[2]);
      seg[3] = seg[3].replace(/^([0-9OIL]+)/, (m) => fixDigits(m));
      if (seg.length === 6) seg[4] = seg[4].replace(/^([0-9OIL])X([0-9OIL])J([0-9OIL]+)$/, (m, a, b, j) => fixDigits(a) + 'X' + fixDigits(b) + 'J' + fixDigits(j));
      s = seg.join('-');
    }
    return s;
  }
  function decodeKey(str) {
    const key = normalizeKey(str);
    const m = key.match(/^([A-Z]\d)-(\d{2,4})-(\d{2,4})-(\d{1,2})([SRC])(\d)([A-Z])(?:-(\d)X(\d)J(\d{2}))?(?:-W(\d))?(?:-K(\d{12}))?(?:-M(\d{4}))?((?:-Z\d{1,4}X\d{1,4}R\d{1,3}L\d{1,4}B\d{1,4})*)-([A-Z0-9]{2})$/);
    if (!m) return { ok: false, error: 'format', key };
    if (m[1] !== VERSION) return { ok: false, error: 'version', key };
    const body = key.slice(0, key.lastIndexOf('-'));
    if (checksum(body) !== m[15]) return { ok: false, error: 'checksum', key };
    const c = cfg();
    const p = { wMm: parseInt(m[2], 10), hMm: parseInt(m[3], 10), thickness: parseInt(m[4], 10), rounded: m[5] === 'R', shape: ({ S: 'straight', R: 'rounded', C: 'curves' })[m[5]], marginLines: parseInt(m[6], 10), material: MATERIAL_BY_CODE[m[7]] || null };
    if (m[13]) { p.marginSides = m[13].split('').map((d) => parseInt(d, 10)); if (sidesUniform(p.marginSides) || p.marginLines !== 0) return { ok: false, error: 'format', key, cfg: p }; }
    if (m[14]) {
      p.cutouts = (m[14].match(/Z\d+X\d+R\d+L\d+B\d+/g) || []).map((z) => { const a = z.match(/Z(\d+)X(\d+)R(\d+)L(\d+)B(\d+)/); return { w: +a[1], h: +a[2], r: +a[3], x: +a[4], y: +a[5] }; });
      if (p.cutouts.length > c.cutoutMax || p.cutouts.some((o) => o.r > 100 || !(o.w > 0 && o.h > 0))) return { ok: false, error: 'format', key, cfg: p };
    }
    if (m[8]) { p.nx = parseInt(m[8], 10); p.ny = parseInt(m[9], 10); p.joint = parseInt(m[10], 10); }
    else { p.nx = 1; p.ny = 1; p.joint = c.jointDefault; }
    if (m[11] && p.shape !== 'curves') return { ok: false, error: 'format', key, cfg: p };
    if (p.shape === 'curves') { p.waves = m[11] ? parseInt(m[11], 10) : 0; if (p.waves > c.curvesMaxLevel) return { ok: false, error: 'format', key, cfg: p }; }
    if (m[12]) {
      if (p.shape !== 'rounded') return { ok: false, error: 'format', key, cfg: p };
      p.corners = [0, 3, 6, 9].map((i) => parseInt(m[12].substr(i, 3), 10));
      if (p.corners.some((v) => v > 100)) return { ok: false, error: 'format', key, cfg: p };
    }
    if (p.wMm < c.minMm || p.wMm > c.maxWMm || p.hMm < c.minMm || p.hMm > c.maxHMm) return { ok: false, error: 'range', key, cfg: p };
    if (p.shape === 'curves' && !curvesFits(p.wMm, p.hMm, c)) return { ok: false, error: 'range', key, cfg: p };
    if (!p.material) return { ok: false, error: 'material', key, cfg: p };
    if (c.jointOptions.indexOf(p.joint) < 0) return { ok: false, error: 'format', key, cfg: p };
    return { ok: true, key, cfg: p };
  }

  /* ---------- aperçu SVG (même géométrie que le configurateur) ---------- */
  const esc = (s) => String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  function logoMarkup(g, fill, opts) {
    if (!g.logo) return '';
    opts = opts || {};
    return '<path class="pegconf-logo" d="' + LOGO_PATH + '" transform="translate(' + g.logo.x.toFixed(2) + ' ' + g.logo.y.toFixed(2) + ')" fill="' + esc(fill || '#efe9dc') + '" fill-rule="evenodd" paint-order="stroke fill" stroke="' + esc(opts.stroke || '#000') + '" stroke-width="' + (opts.strokeWidth || 1.5) + '" stroke-opacity=".9" vector-effect="non-scaling-stroke" stroke-linejoin="round" pointer-events="none"/>';
  }
  /* motifs de trous (un par morceau) : defs + rectangles ; holeClass ou holeFill selon le contexte */
  function holesMarkup(g, idPrefix, holeAttr) {
    let defs = '', rects = '';
    /* Curves : trous listés un par un (ceux trop proches du contour ondulé sont retirés) */
    if (g.holeList) {
      g.holeList.forEach((h) => { rects += '<circle cx="' + h[0] + '" cy="' + h[1] + '" r="' + g.holeR + '" ' + holeAttr + '/>'; });
      return { defs, rects };
    }
    g.pieces.forEach((q, k) => {
      if (!(q.cols > 0 && q.rows > 0)) return;
      const id = idPrefix + '_' + k;
      defs += '<pattern id="' + id + '" x="' + q.gridX + '" y="' + q.gridY + '" width="' + g.spacing + '" height="' + g.spacing + '" patternUnits="userSpaceOnUse"><circle cx="' + (g.spacing / 2) + '" cy="' + (g.spacing / 2) + '" r="' + g.holeR + '" ' + holeAttr + '/></pattern>';
      rects += '<rect x="' + q.gridX + '" y="' + q.gridY + '" width="' + (q.cols * g.spacing) + '" height="' + (q.rows * g.spacing) + '" fill="url(#' + id + ')"/>';
    });
    return { defs, rects };
  }
  /* lignes de coupe : un trait noir simple à chaque jointure */
  function jointsMarkup(g, opts) {
    opts = opts || {};
    const sw = opts.strokeWidth || 1.5, col = opts.stroke || '#000';
    let out = '';
    g.jointsX.forEach((x) => { out += '<line class="pegconf-joint" x1="' + x + '" y1="0" x2="' + x + '" y2="' + g.H + '" stroke="' + esc(col) + '" stroke-width="' + sw + '" vector-effect="non-scaling-stroke"/>'; });
    g.jointsY.forEach((y) => { out += '<line class="pegconf-joint" x1="0" y1="' + y + '" x2="' + g.W + '" y2="' + y + '" stroke="' + esc(col) + '" stroke-width="' + sw + '" vector-effect="non-scaling-stroke"/>'; });
    return out;
  }
  function svg(p, opts) {
    opts = opts || {};
    const g = grid(p);
    const W = g.W, H = g.H, rx = g.cornerR || 4;
    const uniq = 'plan_' + W + 'x' + H + '_' + ((g.cutouts && g.cutouts.length) ? 'z' + g.cutouts.map((o) => o.w + 'x' + o.h + 'r' + o.r + 'l' + o.x + 'b' + o.y).join('_') + '_' : '') + (g.corners ? 'k' + g.corners.join('_') : (g.cornerR ? 'r' : 's')) + '_m' + (g.marginSides ? g.marginSides.join('') : g.marginLines) + '_' + g.nx + 'x' + g.ny + 'j' + g.joint;
    const holes = holesMarkup(g, 'hp_' + uniq, 'fill="' + esc(opts.holeFill || 'rgba(0,0,0,.35)') + '"');
    const body = (g.cutouts && g.cutouts.length)
      ? '<path d="' + bodyPathD(g, g.cornerR || (g.outline ? 0 : 4)) + '" fill="' + esc(opts.fill || '#efe9dc') + '" fill-rule="evenodd" stroke="#333" stroke-width="1" vector-effect="non-scaling-stroke"/>'
      : g.outline
      ? '<path d="' + outlinePath(g, 2) + '" fill="' + esc(opts.fill || '#efe9dc') + '" stroke="#333" stroke-width="1" vector-effect="non-scaling-stroke"/>'
      : '<rect x="0" y="0" width="' + W + '" height="' + H + '" rx="' + rx + '" ry="' + rx + '" fill="' + esc(opts.fill || '#efe9dc') + '" stroke="#333" stroke-width="1" vector-effect="non-scaling-stroke"/>';
    return '<svg viewBox="0 0 ' + W + ' ' + H + '" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" role="img" aria-label="' + esc(opts.title || ('Pegboard ' + W + ' × ' + H + ' mm')) + '">' +
      (holes.defs ? '<defs>' + holes.defs + '</defs>' : '') +
      body +
      holes.rects + logoMarkup(g, opts.logoFill || '#efe9dc', opts) +
      (opts.fixings ? (g.fixings || []).map((f) => '<circle cx="' + f[0] + '" cy="' + f[1] + '" r="' + (g.holeR * 2.6).toFixed(2) + '" fill="none" stroke="#d9480f" stroke-width="2" vector-effect="non-scaling-stroke"/>').join('') : '') +
      (g.outline && g.multi ? '<clipPath id="cj_' + uniq + '"><path d="' + outlinePath(g, 2) + '"/></clipPath><g clip-path="url(#cj_' + uniq + ')">' + jointsMarkup(g) + '</g>' : jointsMarkup(g)) + '</svg>';
  }

  /* ---------- DXF (R12 / AC1009, millimètres, un seul calque) ----------
     Axe y vers le haut : y_dxf = H - y_aperçu. Un contour fermé par morceau,
     en position assemblée (arcs R30 par « bulge » aux coins extérieurs du
     panneau si coins arrondis), trous en cercles Ø 6,1, logo en polylignes
     fermées (courbes de Bézier aplaties). */
  const f = (n) => { const s = (Math.round(n * 1000) / 1000).toString(); return s; };
  function flattenPath(d, segs) {
    const toks = d.match(/[MLCZ]|-?\d*\.?\d+/g) || [];
    const paths = []; let cur = null, i = 0, x = 0, y = 0;
    const n = () => parseFloat(toks[i++]);
    while (i < toks.length) {
      const t = toks[i++];
      if (t === 'M') { x = n(); y = n(); cur = [[x, y]]; paths.push(cur); }
      else if (t === 'L') { x = n(); y = n(); cur.push([x, y]); }
      else if (t === 'C') {
        const x1 = n(), y1 = n(), x2 = n(), y2 = n(), x3 = n(), y3 = n();
        for (let k = 1; k <= segs; k++) {
          const u = k / segs, v = 1 - u;
          cur.push([v * v * v * x + 3 * v * v * u * x1 + 3 * v * u * u * x2 + u * u * u * x3, v * v * v * y + 3 * v * v * u * y1 + 3 * v * u * u * y2 + u * u * u * y3]);
        }
        x = x3; y = y3;
      } else if (t === 'Z') { cur = null; }
    }
    /* supprime le point final identique au premier (polyligne fermée) */
    return paths.map((pts) => { const a = pts[0], b = pts[pts.length - 1]; if (pts.length > 2 && Math.abs(a[0] - b[0]) < 1e-6 && Math.abs(a[1] - b[1]) < 1e-6) pts.pop(); return pts; });
  }
  /* contour d'un morceau (coordonnées DXF, y vers le haut), coins arrondis seulement aux angles du panneau */
  function pieceOutline(q, g) {
    /* Curves : polyligne fine (un point par mm ; écart à la courbe < 0,01 mm) */
    if (g.outline && !g.arcsFit) {
      const pts = g.multi ? clipRect(g.outline(1), q.x, q.y, q.x + q.w, q.y + q.h) : g.outline(1);
      return { pts: pts.map((pt) => [pt[0], g.H - pt[1]]), bulges: null };
    }
    /* rayon de chaque coin : R30 (standard) ou rayons réglables ; les arcs tiennent dans le morceau du coin */
    const R = g.radii || { tl: g.cornerR, tr: g.cornerR, br: g.cornerR, bl: g.cornerR }, H = g.H;
    const x0 = q.x, x1 = q.x + q.w, yTop = H - q.y, yBot = H - (q.y + q.h);
    const b = Math.tan(Math.PI / 8); /* arc de 90° : bulge = tan(θ/4) */
    const pts = [], bulges = [];
    const on = (k) => R[k] > 0 && q.corners[k];
    /* sens anti-horaire depuis le coin bas-gauche */
    if (on('bl')) { pts.push([x0 + R.bl, yBot]); bulges.push(0); } else { pts.push([x0, yBot]); bulges.push(0); }
    if (on('br')) { pts.push([x1 - R.br, yBot]); bulges.push(b); pts.push([x1, yBot + R.br]); bulges.push(0); } else { pts.push([x1, yBot]); bulges.push(0); }
    if (on('tr')) { pts.push([x1, yTop - R.tr]); bulges.push(b); pts.push([x1 - R.tr, yTop]); bulges.push(0); } else { pts.push([x1, yTop]); bulges.push(0); }
    if (on('tl')) { pts.push([x0 + R.tl, yTop]); bulges.push(b); pts.push([x0, yTop - R.tl]); bulges.push(0); } else { pts.push([x0, yTop]); bulges.push(0); }
    if (on('bl')) { pts.push([x0, yBot + R.bl]); bulges.push(b); }
    /* deux arcs qui se rejoignent (coins à 100 %) : sommets confondus -> un seul */
    for (let i = pts.length - 1; i >= 0; i--) {
      const nx = pts[(i + 1) % pts.length];
      if (pts.length > 2 && Math.abs(pts[i][0] - nx[0]) < 1e-6 && Math.abs(pts[i][1] - nx[1]) < 1e-6) {
        /* on garde le sommet suivant avec le bulge du sommet courant (arc qui démarre ici) */
        const bi = bulges[i]; pts.splice(i, 1); bulges.splice(i, 1);
        const j = i % pts.length; if (bi) bulges[j] = bi;
      }
    }
    return { pts, bulges };
  }
  function dxf(p) {
    const g = grid(p);
    const W = g.W, H = g.H, L = 'PEGBOARD', FL = 'FIXATIONS';
    const FIX = new Set((g.fixings || []).map((f) => fixKey(f[0], f[1])));
    const lay = (x, y) => FIX.has(fixKey(x, y)) ? FL : L;
    const out = [];
    const push = (code, val) => { out.push(String(code)); out.push(String(val)); };
    const polyline = (pts, bulges) => {
      push(0, 'POLYLINE'); push(8, L); push(66, 1); push(70, 1); push(10, 0); push(20, 0); push(30, 0);
      pts.forEach((pt, k) => { push(0, 'VERTEX'); push(8, L); push(10, f(pt[0])); push(20, f(pt[1])); push(30, 0); if (bulges && bulges[k]) push(42, f(bulges[k])); });
      push(0, 'SEQEND'); push(8, L);
    };
    /* en-tête */
    push(0, 'SECTION'); push(2, 'HEADER');
    push(9, '$ACADVER'); push(1, 'AC1009');
    push(9, '$INSUNITS'); push(70, 4);
    push(9, '$EXTMIN'); push(10, 0); push(20, 0); push(30, 0);
    push(9, '$EXTMAX'); push(10, W); push(20, H); push(30, 0);
    push(0, 'ENDSEC');
    /* tables : un calque unique */
    push(0, 'SECTION'); push(2, 'TABLES');
    push(0, 'TABLE'); push(2, 'LTYPE'); push(70, 1);
    push(0, 'LTYPE'); push(2, 'CONTINUOUS'); push(70, 0); push(3, 'Solid line'); push(72, 65); push(73, 0); push(40, 0);
    push(0, 'ENDTAB');
    push(0, 'TABLE'); push(2, 'LAYER'); push(70, 3);
    push(0, 'LAYER'); push(2, '0'); push(70, 0); push(62, 7); push(6, 'CONTINUOUS');
    push(0, 'LAYER'); push(2, L); push(70, 0); push(62, 7); push(6, 'CONTINUOUS');
    /* trous de fixation (vis au mur) : mêmes cercles Ø 6,1 que la trame, regroupés sur leur propre calque (rouge) */
    push(0, 'LAYER'); push(2, FL); push(70, 0); push(62, 1); push(6, 'CONTINUOUS');
    push(0, 'ENDTAB');
    push(0, 'ENDSEC');
    /* entités : morceau par morceau (contour puis trous), logo à la fin */
    push(0, 'SECTION'); push(2, 'ENTITIES');
    g.pieces.forEach((q) => {
      const o = pieceOutline(q, g);
      polyline(o.pts, o.bulges);
      if (g.holeList) {
        g.holeList.forEach((h) => { if (h[2] !== g.pieces.indexOf(q)) return; push(0, 'CIRCLE'); push(8, lay(h[0], h[1])); push(10, f(h[0])); push(20, f(H - h[1])); push(30, 0); push(40, f(g.holeR)); });
        return;
      }
      for (let row = 0; row < q.rows; row++) {
        for (let col = 0; col < q.cols; col++) {
          const px = q.x + q.firstCx + col * g.spacing, py = q.y + q.firstCy + row * g.spacing, cx = px, cy = H - py;
          push(0, 'CIRCLE'); push(8, lay(px, py)); push(10, f(cx)); push(20, f(cy)); push(30, 0); push(40, f(g.holeR));
        }
      }
    });
    /* réservations : contour fermé, arcs exacts (bulge) aux angles arrondis ; même calque que les trous (contours intérieurs) */
    (g.cutouts || []).forEach((o) => {
      if (o.notch || o.outside || o.split) return; /* encoche : déjà dans le contour extérieur */
      const b = o.box, R = b.R, x0 = b.x0, x1 = b.x1, yb = H - b.y1, yt = H - b.y0, k = Math.tan(Math.PI / 8);
      const pts = [[x0 + R, yb], [x1 - R, yb], [x1, yb + R], [x1, yt - R], [x1 - R, yt], [x0 + R, yt], [x0, yt - R], [x0, yb + R]];
      const bul = [0, R > 0 ? k : 0, 0, R > 0 ? k : 0, 0, R > 0 ? k : 0, 0, R > 0 ? k : 0];
      for (let i = pts.length - 1; i >= 0; i--) {
        const nx = pts[(i + 1) % pts.length];
        if (pts.length > 2 && Math.abs(pts[i][0] - nx[0]) < 1e-6 && Math.abs(pts[i][1] - nx[1]) < 1e-6) {
          const bi = bul[i]; pts.splice(i, 1); bul.splice(i, 1);
          const j = i % pts.length; if (bi) bul[j] = bi;
        }
      }
      polyline(pts, bul);
    });
    if (g.logo) {
      flattenPath(LOGO_PATH, 16).forEach((pts) => {
        polyline(pts.map((pt) => [g.logo.x + pt[0], H - (g.logo.y + pt[1])]));
      });
    }
    push(0, 'ENDSEC');
    push(0, 'EOF');
    return out.join('\r\n') + '\r\n';
  }

  function filename(p) {
    const g = grid(p);
    const mat = String(p.material || '').toLowerCase() || 'x';
    return 'pegboard-' + g.W + 'x' + g.H + '-P' + Math.round(p.thickness || 0) + '-' + mat + (g.shape === 'curves' ? '-curves' + (g.curves.level ? '-W' + g.curves.level : '') : (g.corners ? '-arrondi-' + g.corners.join('-') : (p.rounded ? '-R30' : ''))) + (g.marginSides ? '-M' + g.marginSides.join('-') : (g.marginLines ? '-M' + g.marginLines : '')) + (g.multi ? '-' + g.nx + 'x' + g.ny + 'pieces-J' + g.joint : '') + ((g.cutouts && g.cutouts.length) ? '-reservations-' + g.cutouts.length : '') + '.dxf';
  }

  window.PEGCONF_PLAN = { VERSION, LOGO_PATH, LOGO_W_MM, LOGO_H_MM, MATERIALS, MATERIAL_LABELS, cfg, grid, pieceCount, encodeKey, decodeKey, normalizeKey, svg, dxf, filename, logoMarkup, holesMarkup, jointsMarkup, curvesSpec, curvesFits, curvesOutline, outlinePath, clipRect, clampCorners, cornerRadii, cornerMaxR, clampCutouts, cutoutBox, cutoutPathD, cutoutIssues, bodyPathD, fixCounts };
})();
